export function deleteSessionStorage(key: string): void {
  sessionStorage.removeItem(key);
}

export function getSessionStorage<TValue = unknown>(
  key: string
): TValue | null {
  try {
    const value = sessionStorage.getItem(key);

    if (value === null) {
      return null;
    }

    return JSON.parse(value) as TValue;
  } catch (error) {
    console.error(`Error getting session storage for ${key}`, error);
    deleteSessionStorage(key);
    return null;
  }
}

export function setSessionStorage<TValue = unknown>(
  key: string,
  value: TValue
): void {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(`Error setting session storage for ${key}`, error);
    deleteSessionStorage(key);
  }
}
